import React, { FC } from 'react';
import { TableRow } from '@material-ui/core';
import TableCell from 'src/components/TableCell';

interface Props {
  error: string;
}

const EmployeeRowError: FC<Props> = ({ error }) => {
  return (
    <TableRow>
      <TableCell colSpan={10} style={{ color: '#f44336' }}>
        {error}
      </TableCell>
    </TableRow>
  );
};

export default EmployeeRowError;
